import * as Yup from 'yup';

export const LoginSchema = Yup.object().shape({
  username: Yup.string()
    .required('Email Required'),
  password: Yup.string()
    .required('Password Required'),
});

export const LoginSchemaSSO = Yup.object().shape({
  username: Yup.string()
    .required('Email or Username Required'),
});

export const AcceptAgreementSchema = Yup.object().shape({
  acceptAgreement: Yup.mixed().oneOf([true], 'Please agree to the terms')
    .required('Please agree to the terms'),
});
